export const BACKEND_URL = {
	login: "login",
	updateToken: "updatetoken",
	register: "register",
	setPassword: "setpassword",
	setPasswordToken: "setpasswordtoken",
	mfaDetails: "MFADetails",
	forgotPassword: "forgotpassword",
	forgotPasswordToken: "forgotpasswordtoken",
	resetPassword: "resetpassword",
	changePassword: "changepassword",
	logout: "logout"
};

export const PAYMENT_URL = {
	sendPaymentFromPaymentApi: "send",
	resubmitPaymentFromPaymentApi: "resend",
	recieverPaymentResponseFromPaymentApi: "response",
	customRecieverPaymentResponseFromPaymentApi: "customresponse",
	transactionStatusFromPaymentApi: "transactionstatus",
	agentListFromPaymentApi: "agentlist",
	getTopPayment: "payment/topPayment",
	sanctionPaymentUpdate: "payment/update-sanctionpayment",
	getrepeatPaymentDetails: "payment/repeatpaymentdetails",
	sendPaymentFromPortal: "payment/send",
	uploadBatchPayment: "payment/uploadbatchpayment",
	downloadFile: "batchdata/download-batch-file",
	rotatePartnerKey: "BatchData/rotate-pmek",
	getRotatedKeyCount: "BatchData/rotated-pmek-count"
};

export const QUOTE_URL = {
	sendExactQuote: "sendexact",
	receiveExactQuote: "receiveexact"
};

export const USER_URL = {
	addUser: "add-user",
	getUserList: "userlist",
	getUserById: "user",
	updateUser: "edit-user",
	changeUserStatus: "user",
	getpartnerUser: "partneruser",
	getPartnerUserById: "partneruser",
	updateStepFlag: "update-stepflag",
	getUser: "users",
	updateUserProfile: "updateuser",
	resendInvite: "resend-invite"
};

export const COMMON_URL = {
	getAllUserRole: "userRole"
};
export const LOG_URL = {
	addLog: "addlog",
	addAuditLog: "addauditlog"
};

export const PARTNER_SECURITY_URL = {
	checkquotes: "partnersecurity-checkquotes",
	submitPayment: "partnersecurity-paymentapi",
	getPaymentLogs: "partnersecurity-paymentlogs",
	getPartnerSecurityByPartnerId: "partnersecurity",
	PartnerSecurityRegenerate: "partnersecurity-regenerate",
	getWebhooksByPartnerId: "partnersecurity-webhooks",
	addPartnerSecurityWebhooks: "add-partnersecurity-webhooks",
	getPartnerSecurityReceiveAPIEndPoints: "partnersecurity-receiveAPIendpoints",
	addPartnerSecurityReceiveEndPoints: "add-partnersecurity-receiveAPIendpoints",
	getpartnerSecurityResponseEndPoint: "partnersecurity-responseAPIendpoint",
	getPartnerSecuritySendAPIEndPoints: "partnersecurity-sendAPIendpoints",
	getPaymentStatus: "partnersecurity-paymentstatus"
};

export const PARTNER_DD_URL = {
	getPartnerPaymentRole: "partner-payment-role",
	getPatrtnerTaxIdType: "partner-taxid-ype",
	getPartnerBusinessType: "partner-business-type",
	getPartnerCompanyType: "partner-company-type",
	getPartnerCompanyDocumentType: "partner-companydoc-type",
	GetPartnerFeeType: "partner-fee-type",
	GetPartnerFeeTier: "partner-fee-tier",
	getPartnerDeliveryType: "partner-delivery-type",
	getPartnerKYBType: "partner-KYB-type",
	getPartnerAccount: "partner-account",
	getPartnerIndividualIdType: "partner-individualid-type",
	getPartnerTransactionType: "partner-transaction-type",
	getPartnerpartnerfacilitator: "partner-facilitator",
	getBasicInfoDropdown: "partner-basicinfo",
	getBasicInfoDropdownById: "partner-basicinfo",
	getCommonDropdown: "partner-all-dropdowns"
};
export const PARTNER_FEES_URL = {
	partnercheckfees: "partner-checkfees",
	getPartnerSendFess: "partner-send-fees",
	getPartnerReceiveFess: "partner-receive-fees",
	addPartnerSendFees: "add-partner-sendfees",
	addPartnerReceiveFees: "add-partner-receivefees"
};

export const DASHBOARD_URL = {
	getDashBoardRecord: "dashboard",
	getNewAndOldCustomer: "new-old-customers",
	getTotalTransactionsVolume: "transaction-volume-data",
	getTopPerformingData: "top-perfrom-data",
	getTotalAmountVolume: "total-amout-volume",
	getPaymentDeliveryTypeData: "payment-delivery-type-data",
	getCurrencyTransactionData: "currency-transaction-data"
};

export const PARTNER_DEPOSIT_URL = {
	getPartnerTranscation: "partner-transactions",
	getTotalBalance: "partner-totalbalance",
	addDepositAmount: "partnerdeposit-amount"
};

export const ADDRESS_URL = {
	getPartnerAddressByPartnerId: "partneraddress",
	addPartnerAddress: "add-partneraddress",
	updatePartnerAddress: "update-partneraddress"
};

export const PARTNER_BASIC_INFO_URL = {
	getPartnerBasicInfo: "partner-information",
	addPartnerBasicInfo: "add-partner-information",
	updatepartnerBasicInfo: "update-partner-Information",
	uploadPartnerLogo: "upload-partner-logo"
};

export const CONTACT_URL = {
	getpartnerContactByPartnerId: "partnercontact",
	addPartnerContact: "add-partnercontact",
	updatePartnerContact: "update-partnercontact"
};

export const PARTNER_CURRENCIES_URL = {
	getCurrenciesByPartnerId: "partnercurrencies",
	addUpdatePartnerCurrencies: "add-update-partnercurrencies"
};

export const PARTNER_DOCUMENTS_URL = {
	getDocumentByPartnerId: "partnerdocument",
	downloadpartnerdocument: "download-partnerdocument",
	addDocumnet: "add-partnerdocument",
	updateDocument: "update-partnerdocument",
	uploadDocument: "upload-partnerdocument",
	deleteDocument: "delete-partnerdocument"
};

export const PARTNER_DOCUMENT_DESCRIPTION_URL = {
	getDocumentDetailsByPartnerId: "documentdescription",
	addDocumentDescription: "add-documentdescription",
	updateDocumentDescription: "update-documentdescription"
};

export const PARTNER_FACILITATOR_URL = {
	getPartnerFacilitatorListByPartnerId: "partnerfacilitator-list",
	addFacilitatorPartner: "add-facilitatorpartner",
	addPartnerFacilitator: "add-partnerfacilitator",
	updatePartnerFacilitator: "update-partnerfacilitator",
	getPartnerFacilitatorByPartenerId: "partnerfacilitator",
	deletePartnerFacilitator: "partnerfacilitator"
};
export const PARTNER_URL = {
	deletePartner: "partner",
	updatePartnerOnboardingStatus: "update-partner-status",
	getstepflagstatusByPartnerId: "step-flag-status",
	getAgentListByCountry: "countrywise-agentlist",
	getAgentBranchesByCountry: "bank-branches",
	getSanction: "sanction",
	fraudList: "list-fraud-event",
	updateFraudEventStatus: "update-fraud-event-status"
};

export const PARTNER_FX_RATE_URL = {
	partnerFxrate: "partnerfxrate",
	addPartnerFxrate: "add-partnerfxrate",
	updatePartnerFxrate: "update-partnerFxrate",
	getFxHistoryById: "fxhistory",
	deletePartnerFxrate: "partnerFxrate",
	getFxRateByPartnerId: "partnerfxrate",
	getRecieveCurrenciesByPartnerid: "partnerFxrate-receive-currencies"
};
export const PARTNERSHIP_DETAILS_URL = {
	addPartnershipDetails: "add-partnershipdetails",
	updatePartnershipDetails: "update-partnershipdetails",
	updateCheckIsfacilitator: "update-checkIsfacilitator",
	getPartnershipDetailsByPartnerId: "partnershipdetails"
};

export const PAYMENT_FIELDS_URL = {
	getPaymentFields: "paymentfields/paymentfieldlist",
	addReceivePaymentField: "paymentfields/receiver-fields",
	getReceiverInformation: "paymentfields/receiver-information",
	addPaymentfieldsSenderFields: "paymentfields/sender-fields",
	addReceiverInformationManadatoryFields: "paymentfields/receiver-manadatory-fields",
	addSenderInformationManadatoryFields: "paymentfields/sender-manadatory-fields",
	getSenderInformation: "paymentfields/sender-information-fields"
};

export const PERSONAL_DETAILS_URL = {
	getPersonalDetailsByPartnerId: "partnerpersonaldetails",
	addPartnerPersonalDetails: "add-partnerpersonaldetails",
	updatePartnerPersonalDetails: "update-partnerpersonaldetails",
	updatePartnerProfile: "update-profile",
	getRiskProfile: "list-risk-rule-config",
	updateRiskProfile: "partner-risk-level-update"
};

export const PAYMENT_TRANSCATION_URL = {
	getPaymentTransaction: "payment-transaction",
	getTransactionByPaymentId: "payment-transaction",
	getBulkPaymentTransaction: "payment-transaction/bulkpaymentdata"
};
export const Wallet_URL = {
	addToPartnerWallet: "add-partnerwallet"
};

export const REPORT_URL = {
	getReportData: "report",
	downloadReportsDetails: "report/export"
};

export const COUNTRY_URL = {
	getCountry: "country-info-list",
	getSendCountryList: "sendcountry-list",
	getCountryList: "receiver-supported-countries",
	getAllCountryList: "all-country-list"
};

export const LOGO_URL = {
	getLogo: "partner/logo"
};
